import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhonePrefixService {

  private prefixesUrl = './assets/phone-prefixes.json';

  constructor(private http: HttpClient) {

   
      
    }
    getPhonePrefixes(): Observable<any[]> {
      return this.http.get<any[]>(this.prefixesUrl);
   }
}
